import {DOCUMENT, Location} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Router, RouterLink} from '@angular/router';
import {Component, inject, Input, OnInit, Renderer2} from '@angular/core';
import {ShoppingService} from '@app/common/services/shopping.service';
import {AppStateService} from '@app/common/services/app-state.service';
import {MAINNAVBARITEMS} from '@app/common/constants/main-nav-bar-items';
import {SingleTourNavbarItems} from '@app/common/constants/single-tour-navbar-items';
import {Language} from "@app/common/interfaces/route-paths";
import {LANGUAGES_OBJ} from "@app/common/constants/languages_data";
import {LngKeys} from "@app/common/enums/lng-keys";
import {redirectToTranslatedPath} from "@app/common/helpers/url-helpers";
import {DropdownComponent} from "@app/common/ui-kits/dropdown/dropdown.component";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    TranslatePipe,
    DropdownComponent,
    RouterLink
  ]
})
export class HeaderComponent implements OnInit {
  private readonly router = inject(Router);
  public readonly location = inject(Location);
  public readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);
  public readonly shoppingService = inject(ShoppingService);
  protected readonly appStateService = inject(AppStateService);

  protected readonly LngKeys = LngKeys;

  @Input() main = true;
  @Input() shopping = false;
  public title = 'Tour de Armenia';
  public navBarItems: { name: string, id: string }[] = [];
  public navBarState = false;

  ngOnInit(): void {
    this.setNavBarItems();
  }

  public toggleBurger(): void {
    this.navBarState = !this.navBarState;
  }

  public scrollTo(id: string): void {
    const element = this.document.getElementById(id) as HTMLElement;
    if (element) {
      element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  protected changeLanguage(event: Language) {
    this.appStateService.setLng(event.key);
    this.appStateService.setHtmlLangAttribute(event.key, this.renderer);
    this.appStateService.addMetaTags(LANGUAGES_OBJ[event.key as LngKeys].seo);

    redirectToTranslatedPath(this.router, event.key);
  }

  private setNavBarItems(): void {
    this.navBarItems = this.main ? MAINNAVBARITEMS : SingleTourNavbarItems;
  }

  public goToShoppingCartPage(): void {
    if (this.shoppingService.shoppedTours.length) {
      this.router.navigateByUrl('shopping-cart');
    }
  }

}



